<template>
  <div>
    <a-form :form="form" layout="vertical">
      <a-form-item label="Company">
        <a-select
          showSearch
          placeholder="Select a company"
          :showArrow="false"
          :filterOption="false"
          :style="{ display: 'inline-block', width: 'calc(80% - 50px)' }"
          @search="getCompaniesDebounce"
          v-model="selectedCompany"
          :notFoundContent="fetchingCompanies ? undefined : null"
          :defaultFirstValue="false">
          <a-spin v-if="fetchingCompanies" slot="notFoundContent" size="small" />
          <a-select-option v-for="c in currentCompanies" :key="c.id">{{ c.name }}</a-select-option>
        </a-select>

      </a-form-item>
      <a-form-item label="Meter">
        <a-select
          showSearch
          placeholder="Select a meter"
          style="width: 100%"
          :showArrow="false"
          :filterOption="false"
          @search="getMetersDebounce"
          v-model="selectedMeter"
          :defaultFirstValue="false"
          :notFoundContent="fetchingMeters ? undefined : null">
          >

          <a-spin v-if="fetchingMeters" slot="notFoundContent" size="small" />
          <a-select-option v-for="s in getMeters" :key="s.id">{{ s.name }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Chart On">
        <a-input-group>
          <the-mask mask="##/##/##" placeholder="mm/dd/yy" v-model="selectedDateOn" style="width:100px" :masked="true" />
          <the-mask mask="##:##" placeholder="hh:mm" v-model="selectedTimeOn" style="width:75px" :masked="true" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="Chart Off">
        <a-input-group compact>
          <the-mask mask="##/##/##" placeholder="mm/dd/yy" v-model="selectedDateOff" style="width:100px" :masked="true" />
          <the-mask mask="##:##" placeholder="hh:mm" v-model="selectedTimeOff" style="width:75px" :masked="true" />
        </a-input-group>

      </a-form-item>
      <a-form-item label="">
        <a-input-group compact>
          <a-checkbox :checked="nilChart" @change="handleNilChartChange">Nil Chart</a-checkbox>
          <a-checkbox :checked="excludeChart" @change="handleExcludeChartChange">Exclude From AutoIntegration</a-checkbox>
        </a-input-group>
      </a-form-item>
      <div v-show="!meterDetailIsEmpty">
        <a-switch v-model="showMeter" checkedChildren="Hide Detail" />
      </div>
      <a-button
        block
        :disabled="isInvalidMetadata"
        :loading="getIsSaving"
        @click="saveMetadata">
        Save
      </a-button>
      <a-button
        block
        @click="cancelMetadata">
        Skip
      </a-button>

    </a-form>
    <div v-show="!meterDetailIsEmpty">
      <ag-grid-vue
        style="width: 100%; height: 200px;"
        class="ag-theme-balham"
        :columnDefs="columnDefs"
        v-model="rowData"
        deltaRowMode
        getRowid>
      </ag-grid-vue>
    </div>
    <a-drawer
      title="Meter Information"
      placement="bottom"
      :closable="true"
      @close="onMeterClose"
      :visible="!meterDetailIsEmpty && showMeter"
      :mask="false">
      <a-input-group>
        <a-input addonBefore="Stream ID:" id="streamIdentifier" v-model="getMeterDetail.streamIdentifier" :read-only="true" :style="{ display: 'inline-block', width: 'calc(33% - 12px)' }" />
        <a-input addonBefore="LSD:" id="lsd" v-model="getMeterDetail.lsd" :read-only="true" :style="{ display: 'inline-block', width: 'calc(33% - 12px)' }" />
        <a-input addonBefore="UWI:" id="uwi" v-model="getMeterDetail.uwi" :read-only="true" :style="{ display: 'inline-block', width: 'calc(33% - 12px)' }" />
        <a-input addonBefore="Stream Description:" id="streamDescription" v-model="getMeterDetail.streamDescription" :read-only="true" :style="{ width: 'calc(20% - 12px)' }" />
        <a-input addonBefore="Site:" id="siteName" v-model="getMeterDetail.siteName" :read-only="true" :style="{ display: 'inline-block', width: 'calc(20% - 12px)' }" />
        <a-input addonBefore="Field:" id="fieldName" v-model="getMeterDetail.fieldName" :read-only="true" :style="{ display: 'inline-block', width: 'calc(20% - 12px)' }" />
        <a-input addonBefore="Contract:" id="contractTime" v-model="getMeterDetail.contractTime" :read-only="true" :style="{ display: 'inline-block', width: 'calc(20% - 12px)' }" />
        <a-input addonBefore="Clock Cycle:" id="clockCycle" v-model="getMeterDetail.clockCycle" :read-only="true" :style="{ display: 'inline-block', width: 'calc(20% - 12px)' }" />
        <a-input addonBefore="Orifice:" id="orifice" v-model="getMeterDetail.orifice" :read-only="true" :style="{ width: 'calc(20% - 12px)' }" />
      </a-input-group>
      <a-textarea addonBefore="Note:" id="note" v-model="getMeterDetail.note" :read-only="true" autosize />
    </a-drawer>

  </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'
import debounce from 'lodash/debounce'
import { TheMask } from 'vue-the-mask'
import moment from 'moment'
import { AgGridVue } from 'ag-grid-vue'
import MeterSearch from '@/components/MeterSearch'

export default {
  components: {
    TheMask,
    AgGridVue,
    MeterSearch
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  created () {

  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
        }
      })
    },
    ...mapActions([
      'getCompanies', 'setQueueItem', 'setCurrentCompany',
      'fetchMeters', 'setCurrentMeter', 'setCurrentCompany', 'setDateOn',
      'setTimeOn', 'setDateOff', 'setTimeOff', 'saveMetadata', 'cancelMetadata', 'setIsNilChart', 'fetchMeterDetail', 'setExcludeChart'
    ]),
    onFirstDataRendered (params) {
      params.api.sizeColumnsToFit()
    },
    onMeterClose () {
      this.showMeter = false
    },
    copyRowData (data) {
      return data.map(datum => {
        return {
          ...datum
        }
      })
    },
    handleNilChartChange (e) {
      this.nilChart = e.target.checked
    },
    handleExcludeChartChange (e) {
      this.excludeChart = e.target.checked
    }
  },
  computed: {
    ...mapGetters([
      'currentQueueItem',
      'currentCompanies',
      'getMeters',
      'fetchingCompanies',
      'fetchingMeters',
      'currentMeter',
      'currentCompany',
      'getDateOn',
      'getTimeOn',
      'getDateOff',
      'getTimeOff',
      'getBatchDetail',
      'getIsSaveError',
      'getSaveStatus',
      'getMeterDetail',
      'getIsSaving',
      'getMeterVolumetric',
      'getIsNilChart',
      'getExcludeChart'
    ]),
    selectedCompany: {
      set (value) {
        this.setCurrentCompany(value)
      },
      get () {
        return this.currentCompany
      }
    },
    selectedMeter: {
      set (value) {
        this.setCurrentMeter(value)
      },
      get () {
        return this.currentMeter
      }
    },
    selectedDateOn: {
      set (value) {
        this.setDateOn(value)
      },
      get () {
        return this.getDateOn
      }
    },
    selectedTimeOn: {
      set (value) {
        this.setTimeOn(value)
      },
      get () {
        return this.getTimeOn
      }
    },
    selectedDateOff: {
      set (value) {
        this.setDateOff(value)
      },
      get () {
        return this.getDateOff
      }
    },
    selectedTimeOff: {
      set (value) {
        this.setTimeOff(value)
      },
      get () {
        return this.getTimeOff
      }
    },
    meterDetailIsEmpty: function () {
      var obj = this.getMeterDetail
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) { return false }
      }
      return true
    },
    isInvalidMetadata: function () {
      var isInvalidValid = this.currentQueueItem == null || this.currentCompany == null || !this.isValidDateTimeOn || !this.isValidDateTimeOff
      return isInvalidValid
    },
    isValidDateTimeOn: function () {
      var strOn = this.selectedDateOn + ' ' + this.selectedTimeOn
      var aDate = moment(strOn, 'MM/DD/YY HH:mm', true)
      var isValid = aDate.isValid()
      return isValid
    },
    isValidDateTimeOff: function () {
      var strOff = this.selectedDateOff + ' ' + this.selectedTimeOff
      var aDate = moment(strOff, 'MM/DD/YY HH:mm', true)
      var isValid = aDate.isValid()
      return isValid
    },
    nilChart: {
      set (value) {
        this.setIsNilChart(value)
      },
      get () {
        return this.getIsNilChart
      }
    },
    excludeChart: {
      set (value) {
        this.setExcludeChart(value)
      },
      get () {
        return this.getExcludeChart
      }
    }
  },
  watch: {
    getIsSaveError (saveErr) {

    },
    getSaveStatus (status) {
      if (status !== '') {
        this.$notification.success({
          message: status,
          description: ''
        })
      }
    },
    getMeterVolumetric () {
      if (this.selectedMeter != null) {
        var data = this.getMeterVolumetric
        if (data !== null && data.length > 0) {
          var md = this.getMeterDetail
          if (md !== '') {
            var dateOn = moment(data[0].dateTimeOff)
            this.selectedDateOn = dateOn.format('MM/DD/YY')
            this.selectedTimeOn = dateOn.format('HH:mm')
            var dateOff = dateOn.add(md.clockCycle, 'h')
            this.selectedDateOff = dateOff.format('MM/DD/YY')
            this.selectedTimeOff = dateOff.format('HH:mm')
            this.rowData = Object.freeze(
              this.copyRowData(data)
            )
          }
        }
      }
    }
  },
  data () {
    this.selectedMeter = null
    this.selectedCompany = null
    this.getCompaniesDebounce = debounce(this.getCompanies, 800)
    this.getMetersDebounce = debounce(this.fetchMeters, 800)

    return {
      columnDefs: [
        {
          headerName: 'Date On',
          field: 'dateTimeOn'
        },
        {
          headerName: 'Date Off',
          field: 'dateTimeOff'
        }
      ],
      rowData: [],
      formItemLayout: {
        labelCol: {
          span: 4
        },
        wrapperCol: {
          span: 20
        }
      },
      config: {
        rules: [{ type: 'object', required: true, message: 'Please select time!' }]
      },
      rangeConfig: {
        rules: [{ type: 'array', required: true, message: 'Please select time!' }]
      },
      showMeter: true
    }
  }

}
</script>

<style lang="css" scoped>
  @import '~ag-grid-community/dist/styles/ag-grid.css';
  @import '~ag-grid-community/dist/styles/ag-theme-balham.css';

  .exchange {
    margin-bottom: 10px;
  }
</style>
